import { validationFactory } from '@hakla/typed-forms'

export const sameAs = validationFactory<[string]>('sameAs')
